
// This script is intentionally loaded immediately, so that it can catch theme:variant:change events.
// As such, avoid any unnecessary slow logic here.

( function () {

	let currentVariant = null;
	document.addEventListener( 'theme:variant:change', e => {
		currentVariant = e.detail.variant;
	} );

	class FindInStoreComponent extends HTMLElement {

		awsUrl = null;
		currentDataLoaded = null;

		_loading = null;

		// #region Event listeners
		connectedCallback() {

			// Listen on open events
			this.querySelectorAll( '[data-find-in-store-modal-opener]' ).forEach( el => el.addEventListener( 'click', e => this.onOpenModalCtaClicked() ) );

			// Listen on close events (close button and backdrop click)
			this.dialogRef.querySelector( '[data-close]' ).addEventListener( 'click', () => {
				this.onCloseModalCtaClicked();
			} );
			this.dialogRef.addEventListener( 'click', ( e ) => {
				if ( e.target === this.dialogRef ) {
					this.onModalBackdropClicked();
				}
			} );

			this._updateCtaVisibility();
			document.addEventListener( 'theme:variant:change', e => {
				this._updateCtaVisibility();
			} );

		}

		onOpenModalCtaClicked() {
			this._open();
		}

		onCloseModalCtaClicked() {
			this._close();
		}

		onModalBackdropClicked() {
			this._close();
		}
		// #endregion

		// #region Private methods
		async _open() {

			// If the currently loaded data is the same as the requested data, there is nothing to do, just show up the previous HTML.
			if ( this.currentDataLoaded === currentVariant.barcode ) {
				console.debug( 'FindInStore', 'Data already loaded' );
				this.dialogRef.showModal();
				return;
			}

			// If the data for this barcode is being loaded, there is nothing to do, just let the previous run finish.
			if ( this.loading === currentVariant.barcode ) {
				console.debug( 'FindInStore', 'Data already loading' );
				this.dialogRef.showModal();
				return;
			}

			const barcode = currentVariant.barcode; // Keep a local reference

			this.error = false;
			this.loading = barcode;

			this._bindProductData();

			this._fetchData().then( newData => {
				if ( this.loading !== barcode ) {
					// A new variant is being loaded, ignore the newly fetched data.
					console.debug( 'FindInStore', 'Data discarded' );
					return;
				}

				this.availableCount = 0;
				this.storeRefs.forEach( el => {
					const storeId = el.dataset.storeId;
					const availableInStore = newData.includes( storeId );

					el.dataset.availableInStore = availableInStore;
					this.availableCount += availableInStore ? 1 : 0;
				} );

				this.loading = false;
				this.currentDataLoaded = barcode;

			}, err => {
				if ( this.loading !== barcode ) {
					// A new variant is being loaded, ignore the error.
					console.debug( 'FindInStore', 'Error discarded' );
					return;
				}

				this.loading = false;
				this.error = err;
				this.availableCount = 0;
				this.currentDataLoaded = null;

				console.debug( 'FindInStore', 'Fetch failed', err );
			} );

			this.dialogRef.showModal();

		}

		async _close() {
			this.dialogRef.close();
		}

		_bindProductData() {
			this.imageSrc = currentVariant.featured_image?.src;
			this.querySelectorAll( '[data-current-variant-title]' ).forEach( el => el.innerText = currentVariant.title );
			this.querySelectorAll( '[data-current-variant-code]' ).forEach( el => el.innerText = ( currentVariant.sku ?? '' ).replaceAll( '_', ' ' ) );
			this.querySelectorAll( '[data-current-variant-barcode]' ).forEach( el => el.innerText = ( currentVariant.barcode ?? '' ) );
			this.querySelectorAll( '[data-current-variant-price]' ).forEach( el => el.innerText = this._formatPrice( currentVariant.price ) );
		}

		async _fetchData() {
			const response = await fetch( this.awsServiceUrl );
			if ( response.status !== 200 )
				throw new Error( `Failed to fetch variant stock data. Response code=${ response.status }` );
			return response.json();
		}

		_updateCtaVisibility() {
			this.querySelectorAll( '[data-find-in-store-modal-opener]' ).forEach( el => el.dataset.enabled = ( currentVariant && currentVariant.barcode ) ? true : false );
		}

		_formatPrice( priceInCents ) {
			return new Intl.NumberFormat( undefined, {
				style: 'currency',
				currency: this.currencyIsoCode,
				maximumFractionDigits: 0,
				currencyDisplay: 'symbol'
			} ).format( priceInCents / 100 ).replace( this.currencySymbol, '' ).trim() + ' ' + this.currencySymbol;
		}
		// #endregion

		// #region Getters
		get awsServiceUrl() {
			return `${ this.dataset.baseUrl }findinstore/${ currentVariant.barcode }`;
		}

		get currencyIsoCode() {
			return this.dataset.currencyIsoCode;
		}

		get currencySymbol() {
			return this.dataset.currencySymbol;
		}

		get dialogRef() {
			return this.querySelector( '[data-find-in-store-modal]' );
		}

		get inventoryRef() {
			return this.querySelector( '[data-find-in-store-inventory]' );
		}

		get storeRefs() {
			return [ ...this.querySelectorAll( '[data-store-id]' ) ];
		}

		set imageSrc( src ) {
			const imageAvailable = ( src && src.length ) ? true : false;
			this.dataset.imageAvailable = imageAvailable;
			this.querySelectorAll( '[data-current-variant-image]' ).forEach( el => el.src = imageAvailable ? src : '' );
		}

		get loading() {
			return this._loading;
		}
		set loading( f ) {
			this._loading = f;
			this.dataset.loading = Boolean( f );
		}

		set error( f ) {
			this.dataset.error = Boolean( f );
		}

		get availableCount() {
			return this._availableCount;
		}
		set availableCount( n ) {
			this._availableCount = n;
			this.dataset.availableCount = n;
			this.dataset.available = n > 0;
		}
		// #endregion

	}

	customElements.define( 'find-in-store', FindInStoreComponent );

} )();
